import { render, staticRenderFns } from "./RecipientInfo.vue?vue&type=template&id=008e0128&scoped=true"
import script from "./RecipientInfo.vue?vue&type=script&lang=js"
export * from "./RecipientInfo.vue?vue&type=script&lang=js"
import style0 from "./RecipientInfo.vue?vue&type=style&index=0&id=008e0128&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e0128",
  null
  
)

export default component.exports